import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { MaintenanceDisplayData } from "@/models/MaintenanceDisplayData";

export default function OutgoingUrlCell(
  params: GridRenderCellParams<MaintenanceDisplayData, string>,
) {
  const currentUrl = window.location.href;
  const jobId = encodeURIComponent(params.row.reference);
  return (
    <Tooltip title="Details">
      <IconButton
        size="small"
        onClick={e => {
          let newUrl = "";
          e.stopPropagation(); // prevent row click
          // Inside geotab
          if (currentUrl.includes("geotab")) {
            newUrl = currentUrl.replace(
              "diagnose_monitor-diagnosticmonitor",
              "auftragsverwaltung-maintenance,job:" + jobId,
            );
          } else {
            if (currentUrl.includes("diagnosticmonitor")) {
              newUrl = currentUrl.replace("diagnosticmonitor", "maintenance?job=" + jobId);
            } else {
              const base = currentUrl.endsWith("/") ? currentUrl.slice(0, -1) : currentUrl;
              newUrl = `${base}/maintenance?job=${jobId}`;
            }
          }
          window.open(newUrl, "_blank", "noopener,noreferrer");
        }}
      >
        <OpenInNewIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
